import React from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/banner/pendent.jpg";
import "../../assets/styles/Collection.css";
import Cta from "../../components/common/Cta";
import ring1 from "../../assets/images/collections/ring1.jpg";
import ring3 from "../../assets/images/collections/ring3.jpg";
import ring4 from "../../assets/images/collections/ring4.jpg";
import ring6 from "../../assets/images/collections/ring6.jpg";
import ring7 from "../../assets/images/collections/ring7.jpg";
import ring8 from "../../assets/images/collections/ring8.jpg";
import ring9 from "../../assets/images/collections/ring9.jpg";
import chain1 from "../../assets/images/collections/chain1.jpg";
import chain2 from "../../assets/images/collections/chain2.jpg";
import chain3 from "../../assets/images/collections/chain3.jpg";
import chain4 from "../../assets/images/collections/chain4.jpg";
import chain5 from "../../assets/images/collections/chain5.jpg";
import chain6 from "../../assets/images/collections/chain6.jpg";
import chain7 from "../../assets/images/collections/chain7.jpg";
import bangles1 from "../../assets/images/collections/bangles1.jpg";
import bangles2 from "../../assets/images/collections/bangles2.jpg";
import bangles3 from "../../assets/images/collections/bangles3.jpg";
import bangles4 from "../../assets/images/collections/bangles4.jpg";
import bangles5 from "../../assets/images/collections/bangles5.jpg";
import bangles6 from "../../assets/images/collections/bangles6.jpg";
import bangles7 from "../../assets/images/collections/bangles7.jpg";
import bangles8 from "../../assets/images/collections/bangles8.jpg";
import necklace from "../../assets/images/collections/necklace.jpg";
import necklace1 from "../../assets/images/collections/necklace1.jpg";
import necklace2 from "../../assets/images/collections/necklace2.jpg";
import necklace3 from "../../assets/images/collections/necklace3.jpg";
import necklace4 from "../../assets/images/collections/necklace4.jpg";
import necklace5 from "../../assets/images/collections/necklace5.jpg";
import necklace6 from "../../assets/images/collections/necklace6.jpg";
import earring from "../../assets/images/collections/earring.jpg";
import earring1 from "../../assets/images/collections/earring1.jpg";
import earring2 from "../../assets/images/collections/earring2.jpg";
import earring3 from "../../assets/images/collections/earring3.jpg";
import earring4 from "../../assets/images/collections/earring4.jpg";
import earring5 from "../../assets/images/collections/earring5.jpg";
import earring6 from "../../assets/images/collections/earring6.jpg";
import earring7 from "../../assets/images/collections/earring7.jpg";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

const Jewellery = () => {
    return (
        <div>
            <Helmet>
                <title>Jewellery Collections</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title={"Jewellery Collections"}
            />
            <div className="site-content">
                <div className="about-area ptb-80">
                    <div className="container-fluid">
                        <section class="gallery-section" id="rings">
                            <div class="section-headers">
                                <div class="section-numbers">01</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Rings</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-rings">
                                <div class="cards tall">
                                    <img src={ring8} alt="Diamond Solitaire Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Diamond Solitaire</p><p class="cards-tag">22K Gold</p> */}
                                    </div>
                                </div>
                                <div class="cards">
                                    <img src={ring1} alt="Emerald Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Emerald Bloom</p><p class="cards-tag">18K Gold</p> */}
                                    </div>
                                </div>
                                <div class="cards">
                                    <img src={ring9} alt="Ruby Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Ruby Royale</p><p class="cards-tag">Platinum</p> */}
                                    </div>
                                </div>
                                <div class="cards">
                                    <img src={ring4} alt="Sapphire Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Sapphire Grace</p><p class="cards-tag">18K Gold</p> */}
                                    </div>
                                </div>
                                <div class="cards wide">
                                    <img src={ring6} alt="Gold Band Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Golden Eternity Band</p><p class="cards-tag">24K Gold</p> */}
                                    </div>
                                </div>
                                <div class="cards">
                                    <img src={ring7} alt="Vintage Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Vintage Halo</p><p class="cards-tag">Rose Gold</p> */}
                                    </div>
                                </div>
                                <div class="cards">
                                    <img src={ring3} alt="Pearl Ring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Pearl Serenity</p><p class="cards-tag">Sterling Silver</p> */}
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="gallery-section" id="chain">
                            <div class="section-headers">
                                <div class="section-numbers">02</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Chain</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-chain">
                                <div class="cards tall">
                                    <img src={chain6} alt="Gold Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Classic Gold Rope</p><p class="cards-tag">22K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain1} alt="Cuban Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Cuban Link</p><p class="cards-tag">18K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain4} alt="Diamond Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Diamond Studded</p><p class="cards-tag">Platinum</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain2} alt="Layered Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Layered Elegance</p><p class="cards-tag">Rose Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain3} alt="Box Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Box Weave</p><p class="cards-tag">Sterling Silver</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain5} alt="Figaro Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Figaro Classic</p><p class="cards-tag">22K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={chain7} alt="Herringbone Chain" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Herringbone Drape</p><p class="cards-tag">18K Gold</p> */}
                                        </div>
                                </div>
                            </div>
                        </section>

                        {/* <section class="gallery-section" id="temple">
                            <div class="section-headers">
                                <div class="section-numbers">03</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Temple Collection</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-temple">
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1601121141461-9d6647bef0a4?w=500&q=80" alt="Temple Jewellery" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1579208570378-8c970854bc23?w=500&q=80" alt="Antique Temple" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1630502894163-87a13d1b8892?w=500&q=80" alt="Goddess Jewellery" />
                                    <div class="cards-overlay">
                                         </div>
                                </div>
                                <div class="cards tall">
                                    <img src="https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=600&q=80" alt="Bridal Temple" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1618500299034-abce7ed0e8df?w=500&q=80" alt="Traditional" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=500&q=80" alt="Peacock Temple" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src="https://images.unsplash.com/photo-1584184924103-e310d9dc82fc?w=500&q=80" alt="Ruby Temple" />
                                    <div class="cards-overlay">
                                        </div>
                                </div>
                            </div>
                        </section> */}

                        <section class="gallery-section" id="bangles">
                            <div class="section-headers">
                                <div class="section-numbers">04</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Bangles</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-bangles">
                                <div class="cards wide">
                                    <img src={bangles5} alt="Gold Bangles" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Classic Gold Stack</p><p class="cards-tag">22K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles2} alt="Kundan Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Kundan Kangan</p><p class="cards-tag">Rajwada Style</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles3} alt="Meenakari Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Meenakari Kada</p><p class="cards-tag">Enamel Work</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles4} alt="Diamond Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Diamond Bangle</p><p class="cards-tag">Platinum</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles1} alt="Silver Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Silver Kada</p><p class="cards-tag">92.5 Silver</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles6} alt="Ruby Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Ruby Studded Kada</p><p class="cards-tag">18K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles7} alt="Pearl Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Pearl Bangle Set</p><p class="cards-tag">Rose Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={bangles8} alt="Bridal Bangle" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Bridal Kangan</p><p class="cards-tag">Bridal Set</p> */}
                                        </div>
                                </div>
                            </div>
                        </section>

                        <section class="gallery-section" id="necklace">
                            <div class="section-headers">
                                <div class="section-numbers">05</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Necklace</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-necklace">
                                <div class="cards tall">
                                    <img src={necklace} alt="Grand Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Grand Haar</p><p class="cards-tag">Bridal Collection</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace1} alt="Choker Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Gold Choker</p><p class="cards-tag">22K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace2} alt="Pearl Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Pearl Rivière</p><p class="cards-tag">Freshwater Pearl</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace3} alt="Diamond Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Diamond Cascade</p><p class="cards-tag">Platinum</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace4} alt="Pendant Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Pendant Necklace</p><p class="cards-tag">18K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace5} alt="Layered Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Layered Set</p><p class="cards-tag">Rose Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={necklace6} alt="Kundan Necklace" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Kundan Mala</p><p class="cards-tag">Rajasthani</p> */}
                                        </div>
                                </div>
                            </div>
                        </section>

                        <section class="gallery-section" id="earrings">
                            <div class="section-headers">
                                <div class="section-numbers">06</div>
                                <div class="section-title-wrap">
                                    <p class="section-labels">Collection</p>
                                    <h2 class="section-titles">Earrings</h2>
                                </div>
                                <div class="section-line"></div>
                            </div>
                            <div class="grid grid-earrings">
                                <div class="cards">
                                    <img src={earring} alt="Jhumka Earrings" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Gold Jhumka</p><p class="cards-tag">22K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={earring2} alt="Diamond Stud" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Diamond Studs</p><p class="cards-tag">Platinum</p> */}
                                        </div>
                                </div>
                                <div class="cards wide tall">
                                    <img src={earring1} alt="Chandelier Earrings" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Chandelier Drops</p><p class="cards-tag">Bridal Collection</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={earring3} alt="Pearl Drop Earrings" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Pearl Drops</p><p class="cards-tag">Freshwater Pearl</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={earring4} alt="Hoop Earrings" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Gold Hoops</p><p class="cards-tag">18K Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={earring7} alt="Chandbali" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Chandbali</p><p class="cards-tag">Antique Gold</p> */}
                                        </div>
                                </div>
                                <div class="cards">
                                    <img src={earring6} alt="Kundan Earring" />
                                    <div class="cards-overlay">
                                        {/* <p class="cards-name">Kundan Drops</p><p class="cards-tag">Meenakari</p> */}
                                        </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <Cta />
        </div>
    );
};

export default Jewellery;
